import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Organization } from 'src/app/classes/organization';
import { ApiService } from 'src/app/services/api.service';
import * as fa from '@fortawesome/free-solid-svg-icons';
import * as faBrands from '@fortawesome/free-brands-svg-icons';
import { City } from 'src/app/classes/city';
import { Geolocation } from '@capacitor/geolocation';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Assignment } from 'src/app/classes/assignment';
import { LocaleSortPipe } from 'src/app/pipes/locale-sort.pipe';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AssignmentComponent } from './assignment/assignment.component';
import { LanguageSelectorComponent } from '../../common/language-selector/language-selector.component';
import Locales from 'src/app/constants/locales';
import { debounceTime, distinctUntilChanged, map, filter } from 'rxjs/operators';
import { Observable, OperatorFunction } from 'rxjs';
import { TranslateFieldPipe } from 'src/app/pipes/translate-field.pipe';
import { Capacitor } from '@capacitor/core';
import { TncComponent } from '../../common/tnc/tnc.component';
import { PrivacyPolicyComponent } from '../../common/privacy-policy/privacy-policy.component';
import { AuthService } from 'src/app/services/auth.service';
import { LocationService } from 'src/app/services/location.service';
import { MessageService } from 'src/app/services/message.service';
import { Badge } from '@capawesome/capacitor-badge';
import { SettingsService } from 'src/app/services/settings.service';
import { CustomerContact } from 'src/app/classes/customer-contact';
import { Feedback } from 'src/app/classes/feedback';
import { FeedbackService } from 'src/app/services/feedback.service';
import { PushNotifications } from '@capacitor/push-notifications';
import { Title } from '@angular/platform-browser';

let cities: City[] = []

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
  providers: [LocaleSortPipe, TranslateFieldPipe],
})


export class AboutComponent implements OnInit {
  defaultYoutubeLink = environment.default_youtube_link
  defaultYoutubeChannelLink = environment.default_youtube_channel_link
  defaultFacebookLink = environment.default_facebook_link
  defaultXLink = environment.default_x_link
  organization = new Organization()
  organizations: Organization[] = []
  assignments: Assignment[] = []
  popularAssignments: Assignment[] = []
  selectedOrganization: any
  environment = environment
  fa = fa
  faBrands = faBrands
  city!: City
  locale = $localize.locale
  locales = Locales
  platform = ''
  isLoggedIn!: boolean | null
  updateCount = true
  messageCount = 0
  currentUser = new CustomerContact()
  location = ''
  copyrightYear = new Date().getFullYear()
  feedbacks: Feedback[] = []
  allOpen = true

  constructor(private apiService: ApiService,
    private authService: AuthService,
    public router: Router,
    private modalService: NgbModal,
    private localeSort: LocaleSortPipe,
    private locationService: LocationService,
    private translateFieldPipe: TranslateFieldPipe,
    private messageService: MessageService,
    private cd: ChangeDetectorRef,
    private settingsService: SettingsService,
    private feedbackService: FeedbackService,
    private titleService: Title
  ) { }

  model!: City;

  formatter = (city: City) => {
    return `${this.translateFieldPipe.transform(city, 'name')}, ${this.translateFieldPipe.transform(city.organization, 'country')}`
  }

  typeaheadSelect(event: any) {
    this.selectCity(event.item)
  }

  search: OperatorFunction<string, readonly { id: any; name: any }[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      filter((term) => term.length >= 1),
      map((term) => cities.filter((city) => new RegExp(term, 'mi').test(this.translateFieldPipe.transform(city, 'name') as string)).slice(0, 10)),
    );

  ngOnInit() {
    this.messageService.init()
    
    this.titleService.setTitle('What is Nuuduu?')

    this.platform = Capacitor.getPlatform()

    if (this.apiService.organizationId()) {
      this.settingsService.organizationPublic().subscribe({
        next: (organization) => {
          this.organization = organization
        },
        error: () => console.log('INFO: Organization not selected yet.')
      })
    }

    this.apiService.organizations().subscribe(organizations => {
      this.organizations = organizations

      cities = []

      for (let organization of organizations) {
        for (let city of organization.cities) {
          cities.push(city)
        }

        if (organizations.length == 1 && organization.id == organizations[0].id) {
          this.selectedOrganization = organization
        }
      }
    })

    if (localStorage.getItem('organization')) {
      this.settingsService.assignmentsPublic().subscribe(assignments => {
        this.assignments = this.localeSort.transform(assignments, 'name')
      })

      this.settingsService.assignmentsPopular().subscribe(assignments => {
        this.popularAssignments = this.localeSort.transform(assignments, 'name')
      })
    }

    else {
      this.settingsService.assignmentsPublic(environment.default_organization_id).subscribe(assignments => {
        this.assignments = this.localeSort.transform(assignments, 'name')
      })

      this.settingsService.assignmentsPopular(environment.default_organization_id).subscribe(assignmentsPopular => {
        this.popularAssignments = assignmentsPopular
      })
    }


    this.authService.isSignedIn().subscribe(result => {
      this.isLoggedIn = result.signed_in

      if (this.isLoggedIn) {
        //this.customerService.current().subscribe(contact => {
        //  this.currentUser = contact
        //})

        this.locationService.listen().subscribe(location => {
          this.location = location
          this.cd.detectChanges()
        })

        this.locationService.listenBalance().subscribe(location => {
          //this.customerService.current().subscribe(contact => {
          //  this.currentUser = contact
          //  this.cd.detectChanges()
          //})
        })

        this.messageService.unread().subscribe(async unread => {
          this.messageCount = parseInt(unread.unread)

          if (Capacitor.getPlatform() != 'web') {
            await Badge.set({ count: parseInt(unread.unread) });
          }
        })

        this.messageService.listen().subscribe(async message => {
          if (this.updateCount) {
            this.messageCount++

            if (Capacitor.getPlatform() != 'web')
              await Badge.set({ count: this.messageCount });
          }
        })

        this.messageService.listenReset().subscribe(data => {
          this.updateCount = data
          this.messageCount = 0
        })
      }
    })

    this.locationService.listen().subscribe(location => {
      this.location = location
      this.cd.detectChanges()
    })

    this.feedbackService.location(`${$localize.locale}`).subscribe(feedbacks => {
      this.feedbacks = feedbacks
    })
  }

  toggleAll() {
    this.allOpen = !this.allOpen
  }

  assignmentOpen(assignment: Assignment) {
    /*
    const modal = this.modalService.open(AssignmentComponent, { centered: true, size: 'lg' })

    modal.componentInstance.assignmentId = assignment.id
    */

    this.router.navigate(['/services', this.translateFieldPipe.transform(assignment, 'slug')])
  }

  moveRandomToFront(arr: any) {
    if (arr.length === 0) return []; // Check if the array is empty

    // Select a random index
    //const randomIndex = Math.floor(Math.random() * arr.length);

    // Remove the element from the random index
    //const element = arr.splice(randomIndex, 1)[0];

    // Insert the element at the front of the array
    //arr.unshift(element);

    return arr; // Optional: return the modified array
  }

  getAddress(event: any) {
    this.apiService.cityByCoordinates(event.geometry.location.lat(), event.geometry.location.lng(), this.apiService.organizationId() as number).subscribe(city => {
      localStorage.setItem('organization', `${city.organization_id}`)
      localStorage.setItem('city', `${city.id}`)
      localStorage.setItem('api_url', `${city.organization.api_url}`)
      localStorage.setItem('ws_url', `${city.organization.ws_url}`)
      localStorage.setItem('country_code', `${city.organization.country_code}`)
      localStorage.removeItem('order')

      this.locationService.updateApiURL()

      this.router.navigate(['/'])
    })
  }

  async getLocation() {
    const coordinates = await Geolocation.getCurrentPosition({ enableHighAccuracy: true, maximumAge: 1000 })

    this.apiService.cityByCoordinates(coordinates.coords.latitude, coordinates.coords.longitude, this.apiService.organizationId() as number).subscribe(city => {
      localStorage.setItem('organization', `${city.organization_id}`)
      localStorage.setItem('city', `${city.id}`)
      localStorage.setItem('api_url', `${city.organization.api_url}`)
      localStorage.setItem('ws_url', `${city.organization.ws_url}`)
      localStorage.setItem('country_code', `${city.organization.country_code}`)
      localStorage.removeItem('order')

      this.locationService.updateApiURL()

      this.router.navigate(['/'])
    })
  }

  selectCity(city: City) {
    localStorage.setItem('organization', `${city.organization_id}`)
    localStorage.setItem('city', `${city.id}`)
    localStorage.setItem('api_url', `${city.organization.api_url}`)
    localStorage.setItem('ws_url', `${city.organization.ws_url}`)
    localStorage.setItem('country_code', `${city.organization.country_code}`)
    localStorage.removeItem('order')

    this.locationService.updateApiURL()
   
    this.router.navigate(['/'])
  }

  selectOrganization(organization: Organization | null) {
    this.selectedOrganization = organization
  }

  languageSelector() {
    const modal = this.modalService.open(LanguageSelectorComponent, { centered: true, size: 'md' })
  }

  tnc() {
    const modal = this.modalService.open(TncComponent, { centered: true, size: 'lg' })

    modal.componentInstance.showAccept = false
  }

  privacyPolicy() {
    const modal = this.modalService.open(PrivacyPolicyComponent, { centered: true, size: 'lg' })
  }
}
